module.exports = __webpack_public_path__ + "static/media/user-filter.e8aeb695.svg";